import React from 'react';
import styles from './heading.module.scss';

type Props = {
  content: string;
  className?: string;
  size: 1 | 2 | 3 | 4 | 5;
};

export const Heading = (props: Props) => {
  const { content, className, size } = props;

  const CustomTag: any = `h${size}`;

  return <CustomTag className={`${styles.heading} ${className || ''}`}>{content}</CustomTag>;
};
